import React from 'react';
import PropTypes from 'prop-types';
import { getUrlWithProtocol } from '../../utils/url';
import Logo from '../Logo';
import './styles.css';

import FavoriteIndicator from '../FavoriteIndicator';

function getCollegeLogoUrl(scid) {
  return `https://static.naviance.com/libraries/college-logos/${scid}.gif`;
}

export function getSchoolDescription(schoolType, schoolLevel, coedStatus) {
  let value = '';

  if (schoolType) {
    value += schoolType;
  }

  if (schoolLevel && /(four|two)/gi.test(schoolLevel)) {
    /* istanbul ignore else */
    if (value.length > 0) {
      value += ', ';
    }

    let level = schoolLevel
      .toLocaleLowerCase()
      .replace(/\sschool/, '')
      .replace(/four/, '4')
      .replace(/two/, '2');

    value += level;
  }

  if (coedStatus) {
    /* istanbul ignore else */
    if (value.length > 0) {
      value += ', ';
    }

    value += coedStatus.toLocaleLowerCase() === 'men and women' ? 'Coed' : coedStatus;
  }

  return (
    value && (
      <React.Fragment>
        <br />
        {value}
      </React.Fragment>
    )
  );
}

export default function SchoolDetails({
  scid,
  schoolName,
  address,
  url,
  urlText,
  collapsed,
  handleCollegeUrlClick,
  coedStatus,
  schoolLevel,
  schoolType,
  ...rest
}) {
  return (
    <div className="school-details-container" data-cy="school-details">
      {collapsed ? null : <Logo src={getCollegeLogoUrl(scid)} alt="School Logo" />}
      <section>
        <div className="school-name-container big-screen">
          <h1 className="school-name-text" data-navi-donottranslate>
            {schoolName}
          </h1>
          <FavoriteIndicator {...rest} />
        </div>
        {collapsed ? null : (
          <span data-cy="school-details-address" onClick={handleCollegeUrlClick}>
            {address}
            {getSchoolDescription(schoolType, schoolLevel, coedStatus)}
            <a
              data-click-location="masthead_url"
              className="school-name-container-url"
              href={getUrlWithProtocol(url)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {urlText}
            </a>
          </span>
        )}
        <div className="school-name-container small-screen">
          <FavoriteIndicator {...rest} />
        </div>
      </section>
    </div>
  );
}

SchoolDetails.propTypes = {
  scid: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.string,
  url: PropTypes.string,
  urlText: PropTypes.string,
  collapsed: PropTypes.bool,
  isFavorite: PropTypes.bool,
  toggleFavorite: PropTypes.func,
  isApplyingTo: PropTypes.bool,
  ceebCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  coedStatus: PropTypes.any,
  schoolLevel: PropTypes.any,
  schoolType: PropTypes.any,
};
